import React from 'react'
import { observer } from 'mobx-react-lite'
import { NavLink, useRouteMatch } from 'react-router-dom'
import clsx from 'clsx'

import { makeStyles } from '@material-ui/core/styles'
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core'

import { extendAccountNavStyles } from './AccountNavigation.styles'

import { RouteWithParams } from '../common/routeUtils'
import { IntegrationRouteParams } from '../common/appRoutes'

import { StoreAccountProps } from '../types/accountProps'
import { integrationKeyByType } from '../types/integrationTypeUtils'

export type AccountNavigationLinkProps =
  StoreAccountProps & {
  route: RouteWithParams<IntegrationRouteParams>

  title: string

  imgSource: string

  selectedImgSource: string
}

export const AccountNavigationLink =
  observer(
    ({
       account, route,
       title, imgSource, selectedImgSource
     }: AccountNavigationLinkProps) => {
      const classes = useStyles()
      const isSelectedLink = !!useRouteMatch(route.template)

      const url = route.makeUrl({
        accountId: account.id,
        integration: integrationKeyByType[account.integrationType]
      })

      return (
        <ListItem
          button
          disableRipple
          component={NavLink}
          to={url}
          className={clsx('nav_account_link', isSelectedLink && 'nav_account_link_selected', classes.listItem)}
        >
          <ListItemIcon
            className={clsx(classes.listItemIcon, 'nav_account_link', isSelectedLink && 'nav_account_link_selected')}>
            <img src={isSelectedLink ? selectedImgSource : imgSource} alt={title}/>
          </ListItemIcon>

          <ListItemText
            className={clsx(classes.listItemText, 'nav_account_link', isSelectedLink && classes.listItemTextSelected)}
            primary={title}
          />
        </ListItem>
      )
    })

const useStyles =
  makeStyles(
    extendAccountNavStyles(
      ({palette}) => ({
        listItemTextSelected: {
          '& span': {
            color: palette.mpSkladPrimary.blue,
            background: '#FFF',
            fontSize: 14,
            fontWeight: 700,
            lineHeight: '14.4px'
          }
        }
      })
    ))